module.exports = __webpack_public_path__ + "static/media/faq-record-selfie.bfd68d38.svg";